import {useEffect, useState} from "react";
import lscache from "lscache";

import {USER_REEL_STATS} from "../../app/constants/storage_keys";

export type IReelStats = Record<string, number>;

export const useUserReelStats = () => {
    const [reelStats, setReelStats] = useState<IReelStats>({});
    const [hasInitialized, setHasInitialized] = useState(false);
    const [currentSessionReelStats, setCurrentSessionReelStats] = useState<IReelStats>({});

    useEffect(() => {
        setReelStats(getReelsPlayStats());
        setHasInitialized(true);

        const handleStorageEvent = (event: StorageEvent) => {
            if (event.storageArea === localStorage && event.key?.endsWith(USER_REEL_STATS)) {
                setReelStats(getReelsPlayStats());
            }
        };

        window.addEventListener("storage", handleStorageEvent);

        return () => {
            window.removeEventListener("storage", handleStorageEvent);
        };
    }, []);

    const getReelsPlayStats = () => {
        if (!lscache.supported()) {
            return {};
        }

        const reelStats = lscache.get(USER_REEL_STATS);

        return {
            ...(reelStats || {})
        };
    };

    const getReelPlayNumber = (reelId: number) => {
        return getReelsPlayStats()[reelId] || 0;
    };

    const increaseReelPlayNumber = (reelId: number) => {
        const newStats = getReelsPlayStats();
        newStats[reelId] = (newStats[reelId] || 0) + 1;
        lscache.set(USER_REEL_STATS, newStats);
        setReelStats(newStats);
        setCurrentSessionReelStats((prevStats) => ({
            ...prevStats,
            [reelId]: (prevStats[reelId] || 0) + 1
        }));
    };

    const resetCurrentSessionReelStats = () => {
        setCurrentSessionReelStats({});
    };

    return {
        reelStats,
        hasInitialized,
        currentSessionReelStats,
        resetCurrentSessionReelStats,
        getReelsPlayStats,
        getReelPlayNumber,
        increaseReelPlayNumber
    };
};
import {useEffect, useState} from "react";
import lscache from "lscache";

import {USER_REEL_STATS} from "../../app/constants/storage_keys";

export type IReelStats = Record<string, number>;

export const useUserReelStats = () => {
    const [reelStats, setReelStats] = useState<IReelStats>({});
    const [hasInitialized, setHasInitialized] = useState(false);
    const [currentSessionReelStats, setCurrentSessionReelStats] = useState<IReelStats>({});

    useEffect(() => {
        setReelStats(getReelsPlayStats());
        setHasInitialized(true);

        const handleStorageEvent = (event: StorageEvent) => {
            if (event.storageArea === localStorage && event.key?.endsWith(USER_REEL_STATS)) {
                setReelStats(getReelsPlayStats());
            }
        };

        window.addEventListener("storage", handleStorageEvent);

        return () => {
            window.removeEventListener("storage", handleStorageEvent);
        };
    }, []);

    const getReelsPlayStats = () => {
        if (!lscache.supported()) {
            return {};
        }

        const reelStats = lscache.get(USER_REEL_STATS);

        return {
            ...(reelStats || {})
        };
    };

    const getReelPlayNumber = (reelId: number) => {
        return getReelsPlayStats()[reelId] || 0;
    };

    const increaseReelPlayNumber = (reelId: number) => {
        const newStats = getReelsPlayStats();
        newStats[reelId] = (newStats[reelId] || 0) + 1;
        lscache.set(USER_REEL_STATS, newStats);
        setReelStats(newStats);
        setCurrentSessionReelStats((prevStats) => ({
            ...prevStats,
            [reelId]: (prevStats[reelId] || 0) + 1
        }));
    };

    const resetCurrentSessionReelStats = () => {
        setCurrentSessionReelStats({});
    };

    return {
        reelStats,
        hasInitialized,
        currentSessionReelStats,
        resetCurrentSessionReelStats,
        getReelsPlayStats,
        getReelPlayNumber,
        increaseReelPlayNumber
    };
};
